//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../GeometricUtilities/GeometricUtilities.CurveRangeBuilder.js";
import "../no/SelectNXObjectList.js";
import "../GeometricUtilities/GeometricUtilities.SurfaceRangeBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/Features.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ColorPlotType",1,0],[1,"ConstraintManager",0,"Features.GeometricConstraintDataManager",0],[1,"CurveRangeControl",0,"GeometricUtilities.CurveRangeBuilder",0],[0,"DeviationIntervals",1,0],[0,"HasAbsoluteColorPlot",1,0],[0,"HasAdditionalValuesLabel",1,0],[0,"HasCrossCurveDeviationLabel",1,0],[0,"HasInfoLabel",1,0],[0,"HasInnerToleranceLabel",1,0],[0,"HasMaximumValueLabel",1,0],[0,"HasMinimumValueLabel",1,0],[0,"InnerTolerance",1,0],[0,"IsColorMapDisplayed",1,0],[0,"IsDirectionReversed",1,0],[0,"IsLabelDisplayed",1,0],[0,"IsMarkerDisplayed",1,0],[0,"IsNeedlePlotDisplayed",1,0],[0,"MaxCheckingAngle",1,0],[0,"MaxCheckingDistance",1,0],[0,"MeasurementMethod",1,0],[0,"MeasurementSamples",1,0],[0,"MinMaxOption",1,0],[0,"NeedleScale",1,0],[0,"NegativeInnerTolerance",1,0],[0,"NegativeOuterTolerance",1,0],[0,"OuterTolerance",1,0],[0,"Plane",1,"Plane",0],[0,"PositiveInnerTolerance",1,0],[0,"PositiveOuterTolerance",1,0],[1,"ReferenceObjects",0,"SelectNXObjectList",0],[0,"ReportingPerType",1,0],[0,"SpatialResolution",1,0],[0,"SuggestScaleFactor",1,0],[1,"SurfaceRangeControl",0,"GeometricUtilities.SurfaceRangeBuilder",0],[1,"TargetObjects",0,"SelectNXObjectList",0],[0,"UseDefiningPoints",1,0],[0,"VectorComponentDirection",1,"Direction",0],[0,"XyzDirection",1,0]],[[[],"AddDynamicPoints",{},0,0],[["snappedObject"],"AddPMILabel",{},1,0]],[]];
SPLM.GeometricAnalysis.DeviationGaugeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.DeviationGaugeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.DeviationGaugeBuilder.MeasurementMethodType = Object.freeze({
    "ThreeDim" : "ThreeDim", "XyzDirection" : "XyzDirection", "WorkView" : "WorkView", "VectorComponent" : "VectorComponent", "Plane" : "Plane", "AlongVector" : "AlongVector"});

SPLM.GeometricAnalysis.DeviationGaugeBuilder.XyzDirectionType = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z"});

SPLM.GeometricAnalysis.DeviationGaugeBuilder.AdditionalValuesLabelType = Object.freeze({
    "UserDefined" : "UserDefined", "Intermediate" : "Intermediate", "All" : "All", "None" : "None"});

SPLM.GeometricAnalysis.DeviationGaugeBuilder.MinMaxType = Object.freeze({
    "Minmax" : "Minmax", "Minimum" : "Minimum", "Maximum" : "Maximum", "None" : "None"});

SPLM.GeometricAnalysis.DeviationGaugeBuilder.ColorPlotTypes = Object.freeze({
    "Blend" : "Blend", "Stepped" : "Stepped", "None" : "None"});

SPLM.GeometricAnalysis.DeviationGaugeBuilder.ReportingPerTypes = Object.freeze({
    "AnalysisObject" : "AnalysisObject", "Target" : "Target", "Reference" : "Reference"});

export default SPLM;